import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function KVKKPage() {
  return (
    <LegalPageLayout title="KVKK Aydınlatma Metni">
      <p>6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz veri sorumlusu sıfatıyla Atak Sistem Enerji tarafından aşağıda açıklanan kapsamda işlenebilecektir.</p>

      <h4>1. Veri Sorumlusu</h4>
      <p>Atak Sistem Enerji olarak, kişisel verilerinizin güvenliği konusunda azami hassasiyet göstermekteyiz. Bu bilinçle, kişisel verileriniz 6698 sayılı KVKK'ya uygun olarak işlenmekte ve saklanmaktadır.</p>

      <h4>2. İşlenen Kişisel Veriler</h4>
      <p>İletişim formu aracılığıyla tarafımıza ilettiğiniz ad, soyad, telefon numarası, e-posta adresi ve mesaj içerikleriniz; hizmet talebinizin karşılanması amacıyla işlenmektedir.</p>

      <h4>3. Kişisel Verilerin İşlenme Amacı</h4>
      <ul>
        <li>Hizmet taleplerinizin karşılanması ve yönetilmesi</li>
        <li>Tarafınıza bilgi ve teklif sunulması</li>
        <li>Müşteri ilişkileri süreçlerinin yürütülmesi</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
      </ul>

      <h4>4. Kişisel Verilerin Aktarılması</h4>
      <p>Kişisel verileriniz, açık rızanız olmaksızın üçüncü kişilerle paylaşılmamaktadır. Yasal zorunluluklar haricinde kişisel verileriniz hiçbir kurum veya kuruluşla paylaşılmaz.</p>

      <h4>5. Kişisel Veri Sahibinin Hakları</h4>
      <p>KVKK'nın 11. maddesi kapsamında; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, işlenme amacını öğrenme, düzeltilmesini isteme, silinmesini talep etme ve itiraz hakkına sahipsiniz.</p>

      <h4>6. İletişim</h4>
      <p>KVKK kapsamındaki haklarınızı kullanmak için bizimle WhatsApp veya telefon üzerinden iletişime geçebilirsiniz.</p>

      <p><strong>Atak Sistem Enerji</strong><br />Balıkesir ve Bölge İllerde Hizmet</p>
    </LegalPageLayout>
  );
}